import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'yat-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormGroupComponent {
  @Input()
  id: string;

  @Input()
  labelFor?: string;

  @Input()
  label?: string | null;

  @Input()
  labelTop: boolean = false;

  @Input()
  optional: boolean = false;
}
